module.exports = __webpack_public_path__ + "img/7_19.5e919a66.png";